import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import PaginatedResponse from '@/types/paginatedResponse';
import { PaginationParams } from '@/types/pagination';
import { PersonChallenge } from '@/types/person_challenge';
import ajax from '@/utils/ajax';

// Challenge-specific pagination parameters
export interface PersonChallengeParams extends PaginationParams {
  not_finished?: boolean;
  finished?: boolean;
  assigned?: boolean;
  recurring?: boolean;
}

const basePath = '/api/dugout/challenges';

const PersonChallengeRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async listByIdPaginated({ id, ...params }: { id: string } & PersonChallengeParams) {
      const response = await ajax.get({
        url: `${host}${basePath}/${id}/`,
        params
      });

      return {
        data: response.data as PaginatedResponse<PersonChallenge[]>,
        isError: false
      };
    },

    async clearCache({ id, ...params }: { id: string } & PersonChallengeParams) {
      const response = await ajax.get({
        url: `${host}${basePath}/${id}/clear-cache/`,
        params
      });

      return {
        data: response.data as PaginatedResponse<PersonChallenge[]>,
        isError: false
      };
    }
  };
};

export default PersonChallengeRepository;
